import i18n from 'qs_vuetify/src/plugins/i18n';
import fr from '@/locales/fr';

i18n.mergeLocaleMessage('fr', fr);

export default i18n;
